import Glightbox from "glightbox";

export default () => {
    const lightboxButtons = document.querySelectorAll(
        ".button[data-glightbox]"
    );

    if (lightboxButtons.length) {
        const init = () => {
            const lightbox = Glightbox({
                touchNavigation: true,
                loop: false,
                selector: ".button[data-glightbox]",
            });
            // console.log(lightbox);

            lightbox.elements.forEach((item, key) => {
                item.node.addEventListener("click", (e) => {
                    lightbox.openAt(key);
                });
            });
        };
        init();
    }
};
